export const PHONE_NUMBER_REGEX = /^(?:\+1\d{10}|\+92\d{10}|\d{10})$/;
